import { useState, type MouseEvent as ReactMouseEvent } from "react";
import { BRAND } from "@/lib/tokens";
import { t } from "@/lib/strings";

// Vertical drag handle between the board (or backdrop) and the docked detail
// panel. A subtle rail that thickens + turns brand-blue on hover/drag. Shared by
// BoardSurface (board split) and TicketDetailOverlay (Home overlay) so both
// resize identically and persist the same ratio.
export function DetailSplitter({
  active,
  onResizeStart,
}: {
  active: boolean;
  onResizeStart: (e: ReactMouseEvent) => void;
}) {
  const [hover, setHover] = useState(false);
  const on = active || hover;
  return (
    <div
      role="separator"
      aria-orientation="vertical"
      aria-label={t.detailResizeAria}
      title={t.detailResizeAria}
      onMouseDown={onResizeStart}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        flexShrink: 0,
        width: 9,
        alignSelf: "stretch",
        cursor: "col-resize",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: on ? 3 : 2,
          height: on ? 46 : 30,
          borderRadius: 999,
          background: on ? BRAND.blue : "var(--hairline-strong)",
          transition: "height .12s ease, width .12s ease, background .12s ease",
        }}
      />
    </div>
  );
}
